import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-admin-access-dialog',
  templateUrl: './admin-access-dialog.component.html',
  styleUrls: ['./admin-access-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminAccessDialogComponent {}
